module.exports = __webpack_public_path__ + "static/media/medium.069c0630.svg";